module.exports = __webpack_public_path__ + "assets/fc8aba5a3e67e37c55d9c56318137765.png";